import React from 'react';

const Logo = ({ 
  variant = 'default', 
  size = 'medium', 
  className = '',
  onClick 
}) => {
  // Logo variants for different use cases
  const logoVariants = {
    // Light backgrounds (navbar, light sections)
    default: '/assets/Scan2CardLogos/Scan2Card_Transparent.png',
    light: '/assets/Scan2CardLogos/Scan2Card_Transparent.png',
    
    // Dark backgrounds (hero, footer, dark sections)
    dark: '/assets/Scan2CardLogos/Scan2Card_OnDarkBGpng.png',
    white: '/assets/Scan2CardLogos/Scan2Card_DarkBG_Transparent.png',
    
    // Transparent versions
    transparent: '/assets/Scan2CardLogos/Scan2Card_Transparent.png',
    variant2: '/assets/Scan2CardLogos/Scan2Card_Varient2.png',
    
    // Favicon/icon
    icon: '/assets/Scan2CardLogos/Scan2Card_Favicon.png',
    favicon: '/assets/Scan2CardLogos/Scan2Card_Favicon.png',
    
    // Fallback to current logo if specific variant doesn't exist
    fallback: '/assets/logo.png'
  };

  // Size configurations
  const sizeConfig = {
    small: { height: '30px' },
    medium: { height: '40px' },
    large: { height: '50px' },
    xlarge: { height: '60px' }
  };

  // Try to use the specific variant, fallback to default logo
  const logoSrc = logoVariants[variant] || logoVariants.fallback;

  return (
    <img 
      src={logoSrc}
      alt="Scan2Card" 
      className={`logo ${className}`}
      style={sizeConfig[size]}
      onClick={onClick}
      onError={(e) => {
        // Fallback to the main logo if variant doesn't exist
        if (e.target.src !== logoVariants.fallback) {
          e.target.src = logoVariants.fallback;
        }
      }}
    />
  );
};

export default Logo;